export default {
    //tableName: 'typequipmentcatalog',

    attributes: {

        id: {
            type: 'number',
            required: true,
            unique: true,
            columnName: 'id'
        },

        name: {
            type: 'string',
            required: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/models/TypeEquipmentCatalog.js